export function keyBy(collection, keyMapper, valueMapper = i => i) {
  return collection.reduce((map, item, index) => {
    const key = keyMapper(item, index);
    map[key] = valueMapper(item, index, map[key]);
    return map;
  }, {});
}